// Home Components Data
export let home_Text: string = "Welcome to Legowen";